<script lang="ts" module>
	export interface ArtistLinksItem {
		Artists_id?: {
			name?: string | null;
			slug?: string | null;
			hide_artist_page?: boolean | null;
		} | null;
	}
</script>

<script lang="ts">
	import { ArtistLink } from '../ArtistLink';
	import { Txt, type TxtVariant } from '$global/components/Txt';

	interface Props {
		artists: (ArtistLinksItem | null)[] | null | undefined;
		// Optional wrapping <Txt> for the whole inline list (e.g. PDP headings).
		txtVariant?: TxtVariant;
		class?: string;
		// Optional <Txt> variant/class applied to each artist name.
		artistTxtVariant?: TxtVariant;
		artistClass?: string;
		// data-cy for the wrapping element.
		dataCy?: string;
		// data-cy for each individual artist link.
		artistDataCy?: string;
	}

	let {
		artists,
		txtVariant,
		class: className,
		artistTxtVariant,
		artistClass,
		dataCy,
		artistDataCy,
	}: Props = $props();
</script>

{#snippet links()}
	{#each artists || [] as artist, i}
		{#if artist}
			{#if !!i}{', '}{/if}<ArtistLink
				dataCy={artistDataCy}
				name={artist.Artists_id?.name ?? ''}
				slug={artist.Artists_id?.slug ?? ''}
				hideArtistPage={artist.Artists_id?.hide_artist_page}
				txtVariant={artistTxtVariant}
				class={artistClass}
			/>{/if}
	{/each}
{/snippet}

{#if txtVariant || className}
	<Txt variant={txtVariant} class={className} data-cy={dataCy}
		>{@render links()}</Txt
	>
{:else}{@render links()}{/if}
